import {Link, useHistory} from "react-router-dom";
import React, {useEffect, useState} from "react";
import List from "./List";
import general from "../../general";
import {NavLink} from "../../lib/Navigation";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import { useScroll, useLockFn } from "ahooks";
import useActiveState from "../../lib/useActiveState";
import Manager from "../components/Manager";
import KeepScroll from "../../lib/KeepScroll";
import TradeListHead from "./TradeListHead";
import TradeListFilter from "./TradeListFilter";

const menus = [
  {
    id: 'submit',
    text: '我要卖号',
    url: '/trade/submit',
    user: true,
  },
  {
    id: 'recovery',
    text: '小号回收',
    url: '/recovery',
    user: true,
  },
  {
    id: 'record',
    text: '交易记录',
    url: '/trade/record',
    user: true,
  },
  {
    id: 'notice',
    text: '交易须知',
    url: '/trade/notice',
    user: true,
  },
  // {
  //   id: 'service',
  //   text: '联系客服',
  //   url: '/service',
  // }
];

const types = [
  {
    id: 'zyjy',
    component: List,
    good:true,
    source:'czjl'
  },
  {
    id: 'gfyx',
    component: List,
    good:false,
    source:''
  },
];

export default props => {
  useEffect(() => {
    // props.setOperate(<Link to="/trade/notice" className="trade-index-notice">交易须知</Link>);
  }, []);
  const history = useHistory();
  const [trades, setTrades] = useState([]);
  const [opacity, setOpacity] = useState();
  const [titleInfo, setTitleInfo] = useState([]);
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [app] = useActiveState('app');
  const [init, setInit] = useState();
  const [index, setIndex] = useState(0);
  const [title_items, setTitle_items] = useState([]);
  const [gfyx_top, set_gfyx_top] = useState(0);
  const [czjl_top, set_czjl_top] = useState(0);

  // ── list-head / list-filter 相关 state ───────────────────────────────────
  const [kw, setKw] = useState('');
  const [inputText, setInputText] = useState('');
  const [sortIng, setSortIng] = useState(false);
  const [sort, setSort] = useState(0);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filter, setFilter] = useState({ sort: 2, type: undefined, device: '0', minPrice: undefined, maxPrice: undefined });
  const [tmpFilter, setTmpFilter] = useState({ sort: 2, device: '0' });

  const scroll = useScroll();
  useEffect(() => {
    let opacity;
    if (props.active) {
      if (scroll.top) {
        opacity = Math.abs(scroll.top) / 200;
        if (opacity > 1) {
          opacity = 1;
        }
      } else {
        opacity = 0;
      }
    }
    setOpacity(opacity);

    if (props.active) {
      // if (scroll.top < -80) {
      //   load();
      // }
    }
  }, [scroll, props.active]);

  //跳转
  const bindHred = (item,index) => {
    Manager.push({event_id:`A-4-${index+2}`})
    if(item.id == 'submit' || item.id == 'recovery') {
      if (app.is_overseas){
        if (!user.email && !user.mobile){
          Dialog.confirm({
            title: '没有绑定邮箱，现在去绑定？',
            yes: () => {
              history.push('/user/email');
            }
          });
        }else{
          history.push(item.url);
        }
      }else{
        if (!user.mobile) {
          Dialog.confirm({
            title: '没有绑定手机号，现在去绑定？',
            yes: () => {
              history.push('/user/phone');
            }
          });
        } else {
          history.push(item.url);
        }
      }
    } else {
      history.push(item.url);
    }
  }

  useEffect(()=>{
    if (props.active){
      const top = scroll.top
      if(index === 0){
        set_gfyx_top(top)
        if (gfyx_top <= 110){
          set_czjl_top(top)
        }
      }else{
        set_czjl_top(top)
        if (czjl_top <= 100){
          set_gfyx_top(top)
        }
      }
    }
  },[scroll,props.active])

  return <div className="trade-index">
    <div className="trade-body">
      {title_items?.length > 0 ? <div className="trade-header" style={{top:(app.is_overseas ? 'calc(env(safe-area-inset-top) + 40px + 40px)' : 'calc(env(safe-area-inset-top) + 40px)')}}>
        <div className={index === 0 ? 'active' : ''} onClick={()=>{
          Manager.push({event_id:'A-4-6'})
          setIndex(0);
          window.scrollTo(0,gfyx_top)
          const container = document.getElementById('trade-super-container')
          container.scrollLeft = 0
        }}>{title_items[0].name}</div>
        <div className={index === 1 ? 'active' : ''} onClick={()=>{
          Manager.push({event_id:'A-4-11'})
          setIndex(1);
          window.scrollTo(0,czjl_top)
          const container = document.getElementById('trade-super-container')
          container.scrollLeft = window.innerWidth
        }}>{title_items[1].name}</div>
      </div> : null
      }

      <TradeListHead
        kw={kw}
        inputText={inputText}
        setKw={setKw}
        setInputText={setInputText}
        sortIng={sortIng}
        setSortIng={setSortIng}
        sort={sort}
        setSort={setSort}
        tmpFilter={tmpFilter}
        onFilterOpen={() => setFilterVisible(true)}
      />

      <TradeListFilter
        visible={filterVisible}
        onClose={() => setFilterVisible(false)}
        tmpFilter={tmpFilter}
        onConfirm={(f) => { setTmpFilter(f); setFilter({ ...f }); }}
      />

      <div style={{ display: title_items?.length > 0 ? 'block' : 'none' }}>
        <div id='trade-super-container' style={{ display: 'flex', overflow: 'hidden' }}>
          {types.map((item, idx) => (
            <div key={idx} style={{ display: (index == idx ? 'block' : 'none'), width: '100%' }}>
              <KeepScroll active={props.active && index == idx}>
                <item.component
                  id={item.id}
                  active={props.active && index == idx}
                  good={item.good}
                  source={item.source}
                  handleTitle={title => setTitle_items(title)}
                  kw={kw}
                  filter={filter}
                  tmpFilter={tmpFilter}
                  onDefaultSort={(sortIndex) => setTmpFilter(prev => ({ ...prev, sort: sortIndex }))}
                />
              </KeepScroll>
            </div>
          ))}
        </div>
        {/* <div style={{display:index===1 ? 'none' : ''}}>
          <List active={index == 0 && props.active} good={false} source='' handleTitle={title=>setTitle_items(title)}/> 
        </div>
        <div style={{display:index===0 ? 'none' : ''}}>
          <List active={index == 1 && props.active} good={true} source='czjl' handleTitle={title=>setTitle_items(title)}/>
        </div> */}
      </div>

    </div>
    
  </div>;
};